module.exports = __webpack_public_path__ + "static/media/berth2.095cf58d.jpg";